import { UnknownAction } from 'redux';
import {
  PatientActionTypes,
  FETCH_PATIENTS_REQUEST,
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENTS_FAILURE,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAILURE,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAILURE,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAILURE,
  SET_SEARCH_TERM,
  SET_CURRENT_PAGE,
} from '../actions/patientActions';
import { PatientData, PaginationData } from '../../services/types';

export interface PatientState {
  patients: PatientData[];
  pagination: PaginationData | null;
  loading: boolean;
  error: string | null;
  searchTerm: string;
  currentPage: number;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
}

const initialState: PatientState = {
  patients: [],
  pagination: null,
  loading: false,
  error: null,
  searchTerm: '',
  currentPage: 1,
  creating: false,
  updating: false,
  deleting: false,
};

const patientReducer = (state = initialState, action: UnknownAction): PatientState => {
  const typedAction = action as PatientActionTypes;
  switch (typedAction.type) {
    case FETCH_PATIENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        patients: typedAction.payload.patients,
        pagination: typedAction.payload.pagination,
        error: null,
      };

    case FETCH_PATIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: typedAction.payload,
        patients: [],
      };

    case CREATE_PATIENT_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case CREATE_PATIENT_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
        // Optionally add the new patient to the list
        // patients: [typedAction.payload, ...state.patients],
      };

    case CREATE_PATIENT_FAILURE:
      return {
        ...state,
        creating: false,
        error: typedAction.payload,
      };

    case UPDATE_PATIENT_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };

    case UPDATE_PATIENT_SUCCESS:
      return {
        ...state,
        updating: false,
        error: null,
        // Update the patient in the list - handle both string and number IDs
        patients: state.patients.map(patient =>
          String(patient.id) === String(typedAction.payload.id) ? typedAction.payload : patient
        ),
      };

    case UPDATE_PATIENT_FAILURE:
      return {
        ...state,
        updating: false,
        error: typedAction.payload,
      };

    case DELETE_PATIENT_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        deleting: false,
        error: null,
        // Remove the patient from the list - handle both string and number IDs
        patients: state.patients.filter(patient => String(patient.id) !== String(typedAction.payload)),
      };

    case DELETE_PATIENT_FAILURE:
      return {
        ...state,
        deleting: false,
        error: typedAction.payload,
      };

    case SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: typedAction.payload,
        currentPage: 1, // Reset to first page when searching
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: typedAction.payload,
      };

    default:
      return state;
  }
};

export default patientReducer;

